import styled from 'styled-components';

export const ChartCard = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
`;

export const ChartHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`;

export const ChartTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 2px 0;
`;

export const ChartSubtitle = styled.div`
  font-size: 11px;
  color: #666666;
  margin: 0;
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 16px;
`;

export const MetricCard = styled.div`
  background: #fafafa;
  border-radius: 10px;
  padding: 12px;
  border: 1px solid #f0f0f0;
`;

export const MetricLabel = styled.div`
  font-size: 11px;
  color: #666666;
  margin-bottom: 4px;
`;

export const MetricValue = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #d81b60;
`;

export const MetricSub = styled.div`
  font-size: 10px;
  color: #137333;
  margin-top: 2px;
  font-weight: 500;
`;
